import { SkeletonText, SkeletonTextLine } from "@vp/swan";
import React from "react";

const PriceLoading = () => {
  return (
    <SkeletonText aria-label="loading">
      <SkeletonTextLine width="narrow"></SkeletonTextLine>
    </SkeletonText>
  );
};

export default PriceLoading;
